<template>
  <section class="hero-section">
    <div class="hero-content">
      <h1 class="hero-title">
        <span class="line1">RAD创造科技</span>
        <span class="line2">重新编写区块链生态</span>
      </h1>
      <button class="hero-btn" @click="routePancake">获取RAD</button>
      <img src="@/assets/image/rusd_svg.svg" alt="" class="hero-nft" />
    </div>
  </section>
</template>
<script>
export default{
  data(){
    return{

    }
  },
  methods:{
    routePancake(){
      window.location.href = 'https://pancakeswap.finance/swap?utm_source=tokenpocket&chain=bsc&inputCurrency=0x55d398326f99059fF775485246999027B3197955&outputCurrency=0xAbB0EDEeD1996C73C6B2E23a4d4B7e303B6906ab'
    }
  }
}
</script>
<style lang="scss" scoped>
.hero-section {
  position: relative;
  overflow: hidden;
}


.hero-content {
  position: relative;
  z-index: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 0 30px;
}

.hero-title {
  display: flex;
  flex-direction: column;
  align-items: center;
  margin: 0 0 36px;
  font-weight: normal;
  text-align: center;  
  padding: 80px 0;
  .line1 {
    margin-bottom: 12px;
    font-size: 70px;
    line-height: 1.3;
    color: #fff;
  }

  .line2 {
    font-size: 70px;
    line-height: 1.3;
    color: #7338ff;
  }
}

.hero-btn {
  width: 100%;
  height: 100px;
  margin-bottom: 36px;
  border: none;
  border-radius: 50px;
  font-size: 32px;
  color: #fff;
  background: #7338ff;
  cursor: pointer;
  transition: opacity 0.2s;
  font-weight: bold;

  &:hover {
    opacity: 0.9;
  }

  &:active {
    opacity: 0.8;
  }
}

.hero-nft {
  display: block;
  width: 100%;
  height: auto;
  object-fit: contain;
}
</style>
